var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumb',{style:({ margin: '20px 10px' })},[_c('BreadcrumbItem',[_vm._v("供应商管理")]),_c('BreadcrumbItem',[_vm._v("编辑供应商")])],1),_c('loading',{attrs:{"loading":_vm.loading,"error":_vm.error}}),_c('formPage',{attrs:{"supplier":_vm.supplier},on:{"handleSubmit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }